import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rodape-tabela-relatorios',
  templateUrl: './rodape-tabela-relatorios.component.html',
  styleUrls: ['./rodape-tabela-relatorios.component.scss']
})
export class RodapeTabelaRelatoriosComponent {
  @Input() tipoRelatorio: any;
  @Input() subTotalModeloInformatica: any;
  @Input() subtotalModeloPb: any;
  @Input() subtotalModeloCor: any;
}
